export default __webpack_public_path__ + "static/media/Suyane_Mike_HickDuarte_32996.21d3e35e.jpg";